import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { HIGHLIGHTS } from '@/constants/content'

export const HighlightsStrip: FC = (): ReactNode => {
    return (
        <section aria-labelledby='highlights-title' className='bg-ink text-white'>
            <h2 id='highlights-title' className='sr-only'>
                What every wash includes
            </h2>

            <Container className='grid gap-8 pb-14 pt-8 sm:grid-cols-2 lg:grid-cols-4 lg:pb-16 lg:pt-10'>
                {HIGHLIGHTS.map(item => (
                    <div key={item.title} className='flex gap-4'>
                        <span className='grid size-12 shrink-0 place-items-center rounded-2xl bg-ink-soft text-aqua ring-1 ring-ink-line'>
                            <item.icon className='size-6' />
                        </span>

                        <div>
                            <h3 className='font-heading text-xl font-bold uppercase tracking-wide'>
                                {item.title}
                            </h3>

                            <p className='mt-1 text-sm leading-relaxed text-white/65'>
                                {item.body}
                            </p>
                        </div>
                    </div>
                ))}
            </Container>
        </section>
    )
}
